<template>
  <div v-if="disabled" 
    class="flex px-2 h-full items-center"
    v-tippy="{ content: 'Edit query to change search options', placement: 'bottom' }">
      <i class="fa-solid fa-gear text-gray-200" />
  </div>
  <Menu v-else as="div" class="relative" v-slot="{ close }">
    <MenuButton class="px-2 h-full rounded disabled:opacity-20 items-center relative 
      text-gray-400 hover:text-gray-600" >
      <i class="fa-solid fa-gear" />
    </MenuButton>

    <transition
      enter-active-class="transition-opacity duration-100 ease-in-out"
      leave-active-class="transition-opacity duration-100 ease-in-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <MenuItems class="absolute z-50 overflow-hidden rounded-md border bg-white text-popover-foreground shadow-md left-0 p-2 font-light text-xs">
        <div class="space-y-4">
          <!-- Match Terms Toggle -->
          <div class="flex justify-end ">
            <div
            v-tippy="{ content: getMatchTermsTippyContent(), allowHTML: true }"
            class="flex flex-row items-center justify-between">
              <span v-html="getMatchTermsText()" />
              <i class="fa-solid fa-info-circle text-xs text-gray-300 ml-1" />
            </div>

            <!--  Toggle switch -->
            <button
              class="relative inline-flex h-5 w-9 flex-shrink-0  rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ml-2"
              :class="matchAnyTerm ? 'bg-blue-500' : 'bg-gray-200'"
              @click="toggleMatchTerms(close)"
            >
              <span
                class="translate-x-0 pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                :class="matchAnyTerm ? 'translate-x-4' : 'translate-x-0'"
              ></span>
            </button>
          </div>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { store } from '../../store'

export default {
  components: {
    Menu,
    MenuButton,
    MenuItems,
    MenuItem
  },
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    
  },
  data() {
    return {
      store,
      liveAddEnabled: true,
      matchAnyTerm: true
    }
  },
  mounted() {
    // Initialize state from store if available
    if (this.store?.currentWatchListId) {
      this.liveAddEnabled = this.store.currentWatchList.automaticallyAddMatchingEvents || true
    }
  },
  methods: {
    toggleLiveAdd(close) {
      this.liveAddEnabled = !this.liveAddEnabled
      
      // Update store if needed
      if (this.store?.currentWatchList) {
        this.store.currentWatchList.automaticallyAddMatchingEvents = this.liveAddEnabled
      }
      
      this.$emit('toggle-live-add', this.liveAddEnabled)
      close()
    },
    toggleMatchTerms(close) {
      this.matchAnyTerm = !this.matchAnyTerm
      this.$emit('toggle-match-terms', this.matchAnyTerm)
      close()
    },
    getMatchTermsTippyContent() {
      return `
      - <strong>ANY</strong>: Search for events matching any keyword. Use it to track all events that match any of the selected keywords.
      <br/><br/>
      - <strong>ALL</strong>: Search for events matching all keywords. Use it to narrow down the search to only include events that match all selected keywords.
      `
    },
    getMatchTermsText() {
      if (this.matchAnyTerm) {
        return 'Match <span class="font-bold">ANY</span> keyword'
      } else {
        return 'Match <span class="font-bold">ALL</span> keywords'
      }
    }
  }
}
</script> 